import React, { useEffect, useState } from "react";
import {
  fetchCroppedImage,
  setShopHomeCms,
  saveThemeJsonData,
} from "../../../../redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import ImageCropper from "../../../imageCropper/imageCropper";

const SectionFourBannerThemeOne = () => {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>();
  const jsonData: any = useSelector<any>((state) => state.shopHomeJsonList);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState("");
  const [cropImageWidth, setCropImageWidth] = useState("");
  const [selectedCropImage, setSelectedCropImage] = useState("");
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imageType, setImageType] = useState("");

  const icons = [
    "assets/img/icons/priorityicon1.svg",
    "assets/img/icons/priorityicon2.svg",
    "assets/img/icons/priorityicon3.svg",
    "assets/img/icons/priorityicon1.svg",
    "assets/img/icons/priorityicon2.svg",
    "assets/img/icons/priorityicon3.svg",
    "assets/img/icons/priorityicon1.svg",
    "assets/img/icons/priorityicon2.svg",
    "assets/img/icons/priorityicon3.svg",
  ];
  const images = [
    "assets/img/home/priorityimg1.jpg",
    "assets/img/home/priorityimg2.jpg",
    "assets/img/home/priorityimg3.jpg",
    "assets/img/home/priorityimg1.jpg",
    "assets/img/home/priorityimg2.jpg",
    "assets/img/home/priorityimg3.jpg",
    "assets/img/home/priorityimg1.jpg",
    "assets/img/home/priorityimg2.jpg",
    "assets/img/home/priorityimg3.jpg",
  ];
  const handleHeaderChange = (e: any, index?: any) => {
    const { value, name } = e.target;
    let updatedCards: any = [...editData.theme_1.home.section_4.cards];
    if (index != undefined) {
      updatedCards = [...editData.theme_1.home.section_4.cards];
      updatedCards[index] = {
        ...updatedCards[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
      home: {
        ...prevJsonData.theme_1.home,
        section_4: {
          ...prevJsonData.theme_1.home.section_4,
          [name]: value,
          cards: updatedCards,
        },
      },
    }
    }));
  };

  const addCollection = () => {
    const updatedCards: any = [...editData.theme_1.home.section_4.cards];

    const newCard = {
      heading: "",
      icon: "assets/img/icons/priorityicon1.svg",
      image: "assets/img/home/priorityimg1.jpg",
      paragraph: "",
    };
    updatedCards.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
      home: {
        ...prevJsonData.theme_1.home,
        section_4: {
          ...prevJsonData.theme_1.home.section_4,
          cards: updatedCards,
        },
      },
    }
    }));
  };
  const removeCard = (index: any) => {
    const updatedCards: any = [...editData.theme_1.home.section_4.cards];
    updatedCards.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
      home: {
        ...prevJsonData.theme_1.home,
        section_4: {
          ...prevJsonData.theme_1.home.section_4,
          cards: updatedCards,
        },
      },
    }
    }));
  };

  const handleIconChange = (image: string, type: string) => {
    const updatedCards = [...editData.theme_1.home.section_4.cards];
    if (type === "icon") {
      updatedCards[activeTab] = {
        ...updatedCards[activeTab],
        icon: image,
      };
    } else {
      updatedCards[activeTab] = {
        ...updatedCards[activeTab],
        image: image,
      };
    }

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
      home: {
        ...prevJsonData.theme_1.home,
        section_4: {
          ...prevJsonData.theme_1.home.section_4,
          cards: updatedCards,
        },
      },
    }
    }));
  };

  const updateImageSection = async (e: any, type: string) => {
    setImageType(type);
    const image = e.target.files[0];
    // if (type === "icon") {
    //   setCropImageHeight("99");
    //   setCropImageWidth("98");
    // } else {
    //   setCropImageHeight("305");
    //   setCropImageWidth("205");
    // }

    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result, type);
      };
    }
  };

  const handleCroppedImage = async (image: any,type:string) => {
    setShowCropModal(false);
    const imageLink = await dispatch(fetchCroppedImage(image));
    if (imageLink != false) {
      handleIconChange(imageLink, type);
    }
  };

  const saveJsonData = () => {
    dispatch(setShopHomeCms(editData));
    dispatch(saveThemeJsonData(editData));
  };

  useEffect(() => {
    setEditData(jsonData);
  }, [jsonData]);
  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);
  useEffect(()=>{setActiveTab(0)},[])
  // HTML
  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Four Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Section Title</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={editData?.theme_1?.home?.section_4?.title}
                        maxLength={250}
                        onChange={handleHeaderChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_1?.home?.section_4?.cards?.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCard(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_1?.home?.section_4?.cards.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? "show active" : ""
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.icon}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                              {icons.map((icons: any, iconIndex: any) => (
                                <SwiperSlide key={iconIndex}>
                                  <div className="img-option">
                                    <img
                                      src={icons}
                                      onClick={() => {
                                        handleIconChange(icons, "icon");
                                      }}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Upload Icon</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(e: any) => {
                            updateImageSection(e, "icon");
                          }}
                          className="form-control"
                          name="image"
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.image}
                              alt={`Card Icon ${index + 1}`}
                            />
                          </div>
                          <div className="img-options w-100">
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                              {images.map((img: any, iconIndex: any) => (
                                <SwiperSlide key={iconIndex}>
                                  <div className="img-option">
                                    <img
                                      src={img}
                                      onClick={() => {
                                        handleIconChange(img, "img");
                                      }}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          className="form-control"
                          onChange={(e: any) => {
                            updateImageSection(e, "img");
                          }}
                          name="image"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Heading<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="heading"
                          value={card.heading}
                          onChange={(e: any) => {
                            handleHeaderChange(e, activeTab);
                          }}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Paragraph</label>
                        <input
                          type="text"
                          className="form-control"
                          name="paragraph"
                          value={card.paragraph}
                          onChange={(e: any) => {
                            handleHeaderChange(e, activeTab);
                          }}
                          maxLength={1200}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div onClick={addCollection} className="col text-center">
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: "block" }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default SectionFourBannerThemeOne;
